module.exports = __webpack_public_path__ + "img/pro_s1_icon5.20d9c193.png";